// Map a router `pathname` to a stable WA_MESSAGES key. Centralised
// here so Header, StickyCTAs, and any future component all stay in
// sync. Replaces a 6-deep nested ternary that was hard to scan.
export const resolveWaKey = (pathname) => {
  if (!pathname || pathname === "/") return "home";
  if (pathname.startsWith("/services/")) {
    return pathname.split("/")[2] || "services";
  }
  if (pathname.startsWith("/services")) return "services";
  if (pathname.startsWith("/about")) return "about";
  if (
    pathname.startsWith("/consultation") ||
    pathname.startsWith("/booking")
  ) {
    return "consultation";
  }
  if (
    pathname.startsWith("/ai-legal") ||
    pathname.startsWith("/consultant") ||
    pathname.startsWith("/document-review") ||
    pathname.startsWith("/case-assessment")
  ) {
    return "ai";
  }
  if (pathname.startsWith("/contact")) return "contact";
  return "home";
};
